import { TFunction } from "i18next"

const rolePermissionBreadCrumb = (t: TFunction<"translation", undefined>) => [
  {
    name: t("rolePermission.breadCrumb"),
  },
]
export default rolePermissionBreadCrumb
